export enum Scenario {
  CART_PRODUCTS = "cart_products",
  CART_CROSS = "cart_cross",
  CARTOVERLAY = "cartoverlay",
  BRANDS = "brands",
  BUNDLES = "bundles",
  BESTSELLERS = "bestsellers",
  CROSS = "cross",
  MULTICROSS = "multicross",
  LAST_SEEN = "last_seen",
  PERSONALIZATION = "personalization",
  CUSTOMERS = "customers",
  PERSONAL_BRAND = "personal_brand",
  PERSONAL_CATEGORY = "personal_category",
  PRODUCTS = "products",
  SPONSORED = "sponsored",
  COMPARISONS = "comparisons",
  SHOPTHELOOK = "shopthelook",
  FLEXIBLE_BESTSELLERS = "flexible_bestsellers",
  FULLY_DYNAMIC = "fully_dynamic",
}

export enum FlexibleScenario {
  BESTSELLERS_CATEGORY_1_PRODUCTBASED_URL = "bestsellers_category_1_productBased_url",
  BESTSELLERS_CATEGORY_2_PRODUCTBASED_URL = "bestsellers_category_2_productBased_url",
  BESTSELLERS_CATEGORY_3_PRODUCTBASED_URL = "bestsellers_category_3_productBased_url",
  BESTSELLERS_CATEGORY_1_PRODUCTBASED_HISTORY = "bestsellers_category_1_productBased_history",
  BESTSELLERS_CATEGORY_2_PRODUCTBASED_HISTORY = "bestsellers_category_2_productBased_history",
  BESTSELLERS_CATEGORY_3_PRODUCTBASED_HISTORY = "bestsellers_category_3_productBased_history",
  BESTSELLERS_BRAND_PRODUCTBASED_URL = "bestsellers_brand_productBased_url",
  BESTSELLERS_BRAND_PRODUCTBASED_HISTORY = "bestsellers_brand_productBased_history",
}

export type ScenarioType = Scenario | FlexibleScenario;

export enum ColorScheme {
  DARK = "DARK",
  LIGHT = "LIGHT",
}

export enum GridBoxType {
  DEFAULT = "default",
  REDUCED = "reduced",
  MINIMAL = "minimal",
  SERECA = "sereca",
  HORIZONTAL_REDUCED = "horizontal-reduced",
}
